import React from 'react';
import { DateTime } from 'luxon';
export var TEXT_TIME_INPUT_FORMAT = 'hh:mm a';
export var getDateTimeFromTimeString = function (rawTimeString) {
    var validPattern = /^(0?[1-9]|1[0-2]):([0-5][0-9])\s?(a|p)$/i;
    var timeString = rawTimeString.toLowerCase();
    if (validPattern.test(rawTimeString)) {
        timeString += 'm';
    }
    var time = DateTime.fromFormat(timeString, TEXT_TIME_INPUT_FORMAT, {
        locale: 'en-US'
    });
    return time.isValid ? time : undefined;
};
export var useTimeRangePickerData = function (_a) {
    var setRangeStart = _a.setRangeStart, setRangeEnd = _a.setRangeEnd, startTime = _a.startTime, endTime = _a.endTime;
    var _b = React.useState(''), startTimeText = _b[0], setStartTimeText = _b[1];
    var _c = React.useState(''), endTimeText = _c[0], setEndTimeText = _c[1];
    React.useEffect(function () {
        if (!startTime) {
            setStartTimeText('');
        }
        else {
            setStartTimeText(startTime.toFormat('hh:mm a').toLowerCase());
        }
    }, [startTime]);
    React.useEffect(function () {
        if (!endTime) {
            setEndTimeText('');
        }
        else {
            setEndTimeText(endTime.toFormat('hh:mm a').toLowerCase());
        }
    }, [endTime]);
    function onStartChange(newStartTime) {
        setStartTimeText(newStartTime);
        setRangeStart(getDateTimeFromTimeString(newStartTime));
    }
    function onEndChange(newEndTime) {
        setEndTimeText(newEndTime);
        setRangeEnd(getDateTimeFromTimeString(newEndTime));
    }
    return {
        startTimeText: startTimeText,
        endTimeText: endTimeText,
        onStartChange: onStartChange,
        onEndChange: onEndChange
    };
};
